import React, { useEffect, useRef, useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

const defaultMessage = "Aconteceu algo inesperado";

export const FeedbackError = ({ error }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    if (error?.statusCode) {
      if (error.body?.details) {
        ref.current = error.body.details[0].message;
        if (!ref.current) {
          ref.current = defaultMessage;
        }
      } else {
        ref.current = error.body?.message || defaultMessage;
      }
    }
    else if (error?.message) {
      ref.current = error.message;
    }
    else {
      ref.current = error;
    }

    setOpen(!!error);
  }, [error]);

  const handleClose = () => setOpen(false);

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="error" sx={{ width: '100%' }}>
        {ref.current}
      </Alert>
    </Snackbar>
  )
}
